import config from '@/config'
import ContentReports from '@/models/ContentReports'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class ContentReportServiceCls extends BaseService<ContentReports> {
  constructor() {
    super(null as any)
  }

  model() {
    return ContentReports
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}/content-reports`
  }

  async reportContent(data: any): Promise<any> {
    const response = await http.post(`${this.endpoint}`, data)
    return response.data
  }

  async getReportedContent(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}`, {
      params: query,
    })
    return response.data
  }

  async getReportedComment(commentId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/comment/${commentId}`)
    return response.data
  }

  async keepReportedContent(reportedContentId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${reportedContentId}/keep`
    )
    return response.data
  }

  async removeReportedContent(
    reportedContentId: string,
    postId: string
  ): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${reportedContentId}/${postId}/remove`
    )
    return response.data
  }
}

// Export singleton instance
export const ContentReportService = new ContentReportServiceCls()

// Export type for dependency injection
export type IContentReportService = ContentReportServiceCls

// Export commonly used methods directly
export const {
  reportContent,
  getReportedContent,
  getReportedComment,
  keepReportedContent,
  removeReportedContent,
} = ContentReportService

// Hook exports
export const useContentReportService = () => {
  return {
    reportContent:
      ContentReportService.reportContent.bind(ContentReportService),
    getReportedContent:
      ContentReportService.getReportedContent.bind(ContentReportService),
    getReportedComment:
      ContentReportService.getReportedComment.bind(ContentReportService),
    keepReportedContent:
      ContentReportService.keepReportedContent.bind(ContentReportService),
    removeReportedContent:
      ContentReportService.removeReportedContent.bind(ContentReportService),
  }
}
